module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "AuditCard my-5",
    attrs: {
      "text": ""
    }
  }, [_c('v-card-title', {
    staticClass: "px-12",
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "space-between"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.deviceData.name))]), _vm._v(" "), (_vm.selectedAuditType === 'pluviometricChart' && _vm.pluviometricChartData && _vm.pluviometricChartData.file && _vm.pluviometricChartData.file.url) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "gap": "8px"
    }
  }, [(_vm.pluviometricChartData && _vm.pluviometricChartData.sharingUrl) ? _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "color": "#0098E1",
      "depressed": "",
      "small": ""
    },
    on: {
      "click": _vm.sharePluviometricChart
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-share")]), _vm._v("\n        Compartir\n      ")], 1) : _vm._e(), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": "",
      "nudge-left": "8",
      "content-class": "pluviometric-download-menu",
      "transition": "scale-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "black"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-dots-vertical")])], 1)]
      }
    }], null, false, 1508904250)
  }, [_vm._v(" "), _c('v-btn', {
    staticClass: "rounded-pill pluviometric-download-btn",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        return _vm.downloadPdf('pluviometricChart')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-download")]), _vm._v("\n          Descargar\n        ")], 1)], 1)], 1) : (
    (_vm.selectedAuditType === 'audit' && _vm.auditData && _vm.auditData.pdfFile && _vm.auditData.pdfFile.url) ||
    (_vm.selectedAuditType === 'flowMeasurement' && _vm.flowMeasurementData && _vm.flowMeasurementData.pdfFile && _vm.flowMeasurementData.pdfFile.url) ||
    (_vm.selectedAuditType === 'uniformity' && _vm.uniformityData && _vm.uniformityData.pdfFile && _vm.uniformityData.pdfFile.url)) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "black"
    },
    on: {
      "click": function($event) {
        return _vm.downloadPdf(_vm.selectedAuditType)
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-download")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', {
    staticClass: "EquipmentSummary px-12",
    attrs: {
      "row": "",
      "no-wrap": ""
    }
  }, [_c('v-col', {
    staticClass: "EquipmentItem EquipmentAuditType pa-0",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-radio-group', {
    attrs: {
      "mandatory": ""
    },
    model: {
      value: (_vm.selectedAuditType),
      callback: function($$v) {
        _vm.selectedAuditType = $$v
      },
      expression: "selectedAuditType"
    }
  }, _vm._l((_vm.filteredAuditTypes), function(auditType) {
    return _c('v-radio', {
      key: auditType.value,
      style: ({
        'font-weight': _vm.selectedAuditType === auditType ? '600' : '400'
      }),
      attrs: {
        "label": auditType.label,
        "value": auditType.value,
        "color": "#0098E1"
      },
      scopedSlots: _vm._u([{
        key: "label",
        fn: function() {
          return [_c('div', [_vm._v(_vm._s(auditType.label)), ((auditType.value === 'audit' && _vm.auditData && _vm.auditData.isPublished === false) || (auditType.value === 'flowMeasurement' && _vm.flowMeasurementData && _vm.flowMeasurementData.isPublished === false) || (auditType.value === 'pluviometricChart' && _vm.pluviometricChartData && _vm.pluviometricChartData.isPublished === false) || (auditType.value === 'uniformity' && _vm.uniformityData && _vm.uniformityData.isPublished === false)) ? _c('v-icon', {
            staticClass: "icon-center",
            attrs: {
              "small": "",
              "color": "warning"
            }
          }, [_vm._v("priority_high")]) : _vm._e()], 1)]
        },
        proxy: true
      }], null, true)
    })
  }), 1)], 1), _vm._v(" "), (_vm.selectedAuditType === 'audit' && _vm.auditData) ? [_c('v-col', {
    staticClass: "EquipmentItem EquipmentItemMetricFlex text-center pa-0",
    attrs: {
      "xs3": ""
    }
  }, [_c('p', {
    staticClass: "subheading px-2"
  }, [_vm._v("Caudal de pluviometría relevada")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "1",
      "align-content": "center"
    }
  }, [_c('div', {
    staticClass: "my-3 py-3"
  }, [_c('p', {
    staticClass: "display-1 ma-0 mb-1 d-inline",
    staticStyle: {
      "color": "#00202F"
    }
  }, [_vm._v(_vm._s(_vm.auditData.calculatedData ? _vm.formatNumber(_vm.auditData.calculatedData.totalFlow) : '-'))]), _vm._v(" "), _c('p', {
    staticClass: "unit-text ma-0 d-inline",
    staticStyle: {
      "color": "#00202F"
    }
  }, [_vm._v("m3/h")])])])]), _vm._v(" "), _c('v-col', {
    staticClass: "EquipmentItem text-center pa-0",
    attrs: {
      "xs3": ""
    }
  }, [_c('p', {
    staticClass: "subheading px-2"
  }, [_vm._v("Uniformidad de pluviometría relevada")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "1",
      "align-content": "center"
    }
  }, [_c('v-progress-circular', {
    staticClass: "ItemValue",
    attrs: {
      "rotate": -90,
      "size": 120,
      "width": 5,
      "value": _vm.auditData.calculatedData && _vm.auditData.calculatedData.pluviometricUniformity || 0,
      "color": "#0098E1"
    }
  }, [_c('p', {
    staticClass: "display-1 ma-0",
    staticStyle: {
      "color": "#00202F"
    }
  }, [_vm._v(_vm._s(_vm.auditData.calculatedData ? ((_vm.formatNumber(_vm.auditData.calculatedData.pluviometricUniformity)) + "%") : '-'))])])], 1)]), _vm._v(" "), _c('v-col', {
    staticClass: "EquipmentItem text-center pa-0",
    attrs: {
      "xs3": ""
    }
  }, [_c('p', {
    staticClass: "subheading px-2"
  }, [_vm._v("Bajantes con configuración correcta")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "1",
      "align-content": "center"
    }
  }, [_c('v-progress-circular', {
    staticClass: "ItemValue",
    attrs: {
      "rotate": -90,
      "size": 120,
      "width": 5,
      "value": _vm.outletsConfigurationAnalysis.percentage,
      "color": "#0098E1"
    }
  }, [_c('p', {
    staticClass: "display-1 ma-0",
    staticStyle: {
      "color": "#00202F"
    }
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.outletsConfigurationAnalysis.percentage)) + "%")]), _vm._v(" "), _c('p', {
    class: {
      caption: true,
      'ma-0': true
    },
    staticStyle: {
      "color": "#00202F"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.outletsConfigurationAnalysis.correct) + " de " + _vm._s(_vm.outletsConfigurationAnalysis.total) + "\n            ")])])], 1)])] : (_vm.selectedAuditType === 'flowMeasurement' && _vm.flowMeasurementData) ? [_c('v-col', {
    staticClass: "EquipmentItem EquipmentItemMetricFlex text-center pa-0",
    attrs: {
      "cols": "9"
    }
  }, [_c('p', {
    staticClass: "subheading px-2"
  }, [_vm._v("Caudal medido")]), _vm._v(" "), _c('div', {
    staticClass: "mb-3 pb-3"
  }, [_c('p', {
    staticClass: "display-1 ma-0 mb-1 d-inline",
    staticStyle: {
      "color": "#00202F"
    }
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.flowMeasurementAverageFlow)))]), _vm._v(" "), _c('p', {
    staticClass: "unit-text ma-0 d-inline",
    staticStyle: {
      "color": "#00202F"
    }
  }, [_vm._v("m3/h")])])])] : (_vm.selectedAuditType === 'pluviometricChart' && _vm.pluviometricChartData && _vm.showPluviometricChart) ? _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('PluviometricChart', {
    key: _vm.pluviometricChartInstanceKey,
    attrs: {
      "pluviometricChartData": _vm.pluviometricChartData
    }
  })], 1) : (_vm.selectedAuditType === 'pluviometricChart' && _vm.pluviometricChartData && !_vm.showPluviometricChart) ? _c('v-col', {
    staticClass: "d-flex align-center justify-center",
    staticStyle: {
      "min-height": "200px"
    },
    attrs: {
      "cols": "9"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "#0098E1"
    }
  })], 1) : (_vm.selectedAuditType === 'uniformity' && _vm.uniformityData) ? [_c('v-col', {
    staticClass: "EquipmentItem EquipmentItemMetricFlex text-center pa-0",
    attrs: {
      "xs6": ""
    }
  }, [_c('p', {
    staticClass: "subheading px-2"
  }, [_vm._v("Coeficiente de uniformidad")]), _vm._v(" "), _c('div', {
    staticClass: "mb-3 pb-3"
  }, [_c('p', {
    staticClass: "display-1 ma-0 mb-1 d-inline",
    style: ({
      color: _vm.getUniformityColor(_vm.uniformityData.coefficientOfUniformity)
    })
  }, [_vm._v(_vm._s(_vm.uniformityData.coefficientOfUniformity ? ((_vm.formatNumber(_vm.uniformityData.coefficientOfUniformity)) + "%") : '-'))])])]), _vm._v(" "), _c('v-col', {
    staticClass: "EquipmentItem EquipmentItemMetricFlex text-center pa-0",
    staticStyle: {
      "border-left": "none !important"
    },
    attrs: {
      "xs6": ""
    }
  }, [_c('p', {
    staticClass: "subheading px-2"
  }, [_vm._v("Desviación contra configuración")]), _vm._v(" "), _c('div', {
    staticClass: "mb-3 pb-3",
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [(_vm.uniformityData.deviationAgainstConfiguration !== null && _vm.uniformityData.deviationAgainstConfiguration !== undefined) ? _c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "color": _vm.getDeviationIconColor(_vm.uniformityData.deviationAgainstConfiguration)
    }
  }, [_vm._v(_vm._s(_vm.getDeviationIcon(_vm.uniformityData.deviationAgainstConfiguration)))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "display-1 ma-0 mb-1 d-inline",
    staticStyle: {
      "color": "#00202F"
    }
  }, [_vm._v(_vm._s(_vm.uniformityData.deviationAgainstConfiguration !== null && _vm.uniformityData.deviationAgainstConfiguration !== undefined ? ((_vm.formatDeviation(_vm.uniformityData.deviationAgainstConfiguration)) + "%") : '-'))])], 1)])] : _vm._e()], 2), _vm._v(" "), (['audit', 'flowMeasurement', 'uniformity'].includes(_vm.selectedAuditType)) ? _c('CardExpansionPanel', {
    attrs: {
      "auditType": _vm.selectedAuditType,
      "auditData": _vm.auditData,
      "flowMeasurementData": _vm.flowMeasurementData,
      "uniformityData": _vm.uniformityData
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2070bbcf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Audits/MainCard.vue
// module id = 1699
// module chunks = 0